export default __webpack_public_path__ + "static/media/CSC.2cc37f4b.png";